import { logoSrc, type LogoBody } from '@affdice/portal-kit';

/** The two calls the logo modal makes — the part of `PlatformApi` it needs. */
export interface BrandLogoApi {
  readonly apiBaseUrl: string;
  setBrandLogo(brandId: string, body: LogoBody, reason: string): Promise<{ logo_url: string }>;
  removeBrandLogo(brandId: string, reason: string): Promise<void>;
}

/** The saved logo as an address this console can load, or nothing. */
export function brandLogoSrc(api: Pick<BrandLogoApi, 'apiBaseUrl'>, logoUrl: string | null | undefined): string | undefined {
  return logoSrc(api.apiBaseUrl, logoUrl);
}

/**
 * What the modal's save and remove do: call the API, then tell the screen the
 * new path (or null once removed). A failed call rejects and tells nobody, so
 * the upload shows the error and the list keeps the old logo.
 */
export function brandLogoActions(
  api: BrandLogoApi,
  brandId: string,
  /** The reason as typed when the button is pressed (trimmed here). */
  reason: () => string,
  onChanged: (logoUrl: string | null) => void,
): { save(body: LogoBody): Promise<void>; remove(): Promise<void> } {
  return {
    save: (body) => api.setBrandLogo(brandId, body, reason().trim()).then((r) => onChanged(r.logo_url)),
    remove: () => api.removeBrandLogo(brandId, reason().trim()).then(() => onChanged(null)),
  };
}
